var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"share-campaign-container"},[_c('ShareButtons',{attrs:{"origin":_vm.origin,"shareData":{ url: _vm.shareLink || _vm.landingLink }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }